import { useAppDispatch, useAppSelector } from '@shared/model';
import { closeModal, selectModalState, showModal } from '@shared/ui/modals';

const useModal = (modalTag: string) => {
  const dispatch = useAppDispatch();
  const { isOpen, tag } = useAppSelector(selectModalState);

  const isShowModal = isOpen && tag === modalTag;

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleOpen = () => {
    dispatch(showModal(modalTag));
  };

  return {
    isOpen: isShowModal,
    handleOpen,
    handleClose,
  };
};

export default useModal;
